import { contractorApi } from '@/lib/api'

export function signTaxForm(data: {
  taxFormId: string
  signedByFullName: string
}) {
  return contractorApi.post('/v1/contractor-onboarding/sign-tax-form', data)
}
